import newPolicyActions from "./newPolicyActions";

export default newPolicyActions;
